/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';

type Option = {
  value: string | number,
  label: string,
  disabled?: boolean,
  actions?: JSX.Element[],
}

type ActionOption = {
  className?: string,
  content: JSX.Element,
  onClick: () => void,
}

interface Props {
  label?: string,
  placeholder?: string,
  options: Option[],
  actionOptions?: ActionOption[],
  bottomActionOptions?: ActionOption[],
  value?: string | number,
  isSearchable?: boolean,
  onChange?: (e: any) => void,
  onInputChange?: (e: any) => void,
}

const SelectActions = ({
  label = '',
  placeholder = '',
  options = [],
  actionOptions = [],
  bottomActionOptions = [],
  value,
  isSearchable = false,
  onChange = () => {},
  onInputChange,
}: Props) => {

  const [show, setShow] = useState(false);
  const [selected, setSelected] = useState<Option>();
  const [inputValue, setInputValue] = useState<string>('');
  const [filteredOptions, setFilteredOptions] = useState<Option[]>(options);

  const selectOption = (item: Option) => {
    setSelected(item);
    setShow(false);
    if (item.value !== selected?.value)
      onChange(item.value);
  }

  const onSearch = (newValue: string) => {
    setSelected(undefined);
    setInputValue(newValue);

    if (onInputChange) return onInputChange(newValue);
    if (!newValue) return setFilteredOptions(options);

    const filtered = options.filter(i => {
      return Object.entries(i)
        .filter(val => ['string','number'].includes(typeof val[1]))
        .some(val => String(val[1]).toLowerCase().includes(String(newValue).toLowerCase()));
    });
    setFilteredOptions(filtered);
  }

  const updateValue = () => {
    const exists = options.find(x => x.value === value);
    if (exists) setSelected(exists);
    else setSelected(undefined);
  }

  useEffect(() => {
    updateValue();
  }, [value, options]);

  useEffect(() => {
    setFilteredOptions(options);
  }, [options]);

  return (
    <>
      {show && (
        <div className="backdrop" onClick={() => setShow(false)} />
      )}

      <div className="custom-actions-select-wrapper">
        <div className="form-group custom-actions-select" onClick={() => setShow(true)}>
          <label>{ label }</label>
          <div className="input-wrapper">
              {isSearchable ? (
                <input
                  className="form-control"
                  value={ selected?.label || inputValue || '' }
                  placeholder={placeholder}
                  onChange={e =>  onSearch(e.target.value)}
                />
              ) : (
                <div className="form-control">
                  <span>{ selected?.label || placeholder || '' }</span>
                </div>
              )}
            <div className="dropdown-tip">
              <i className="fa fa-regular fa-chevron-down"></i>
            </div>
          </div>
        </div>

        {show && (
          <ul className="custom-actions-options">
            {actionOptions.map((option, index) => (
              <li
                key={`${label || placeholder}-action-as-option-${index}`}
                className={`action-as-option green ${ option?.className }`}
                onClick={() => option.onClick()}
              >
                { option.content }
              </li>
            ))}

            {filteredOptions.map((option, index) => (
              <li
                key={`${label || placeholder}-option-${index}`}
                className={option?.disabled ? 'disabled' : ''}
              >
                <span
                  className="label"
                  title={ typeof option.label === 'string' ? option.label : undefined }
                  onClick={() => option?.disabled ? {} : selectOption(option)}
                >
                  { option.label }
                </span>
                {!!option?.actions && (
                  <div className="actions">{ option?.actions }</div>
                )}
              </li>
            ))}

            {bottomActionOptions.map((option, index) => (
              <li
                key={`${label || placeholder}-bottom-action-as-option-${index}`}
                className={`bottom-action-as-option blue ${ option?.className }`}
                onClick={() => option.onClick()}
              >
                { option.content }
              </li>
            ))}
          </ul>
        )}
      </div>
    </>
  )
}

export default SelectActions;